import React from 'react';
import { List, ListItem, ListItemButton, ListItemText, Typography, Box } from '@mui/material';
import { useGetCompanyChatsQuery } from '../../../api/dieter/companyChat/hooks';

interface CompanyChatListProps {
  onSelectChat: (chatId: string) => void;
  selectedChatId?: string;
}

export function CompanyChatList({ onSelectChat, selectedChatId }: CompanyChatListProps) {
  const { data, loading, error } = useGetCompanyChatsQuery();

  if (loading) return <Typography>Loading chats...</Typography>;
  if (error) return <Typography color="error">Error loading chats</Typography>;

  const chats = data?.getCompanyChats || [];

  return (
    <List>
      {chats.map((chat: any) => {
        const lastMessage = chat.messages[0];
        const isSelected = chat.id === selectedChatId;

        return (
          <ListItem key={chat.id} disablePadding>
            <ListItemButton
              selected={isSelected}
              onClick={() => onSelectChat(chat.id)}
            >
              <ListItemText
                primary={chat.title}
                secondary={
                  <Box>
                    {lastMessage && (
                      <Typography variant="caption" noWrap>
                        {lastMessage.sender?.firstName}: {lastMessage.content}
                      </Typography>
                    )}
                    <Typography variant="caption" color="text.secondary" display="block">
                      {new Date(chat.updatedAt).toLocaleDateString()}
                    </Typography>
                  </Box>
                }
              />
            </ListItemButton>
          </ListItem>
        );
      })}
    </List>
  );
}
